import React from 'react';
import $ from 'jquery';
import './App.css';
import { initializeApp } from 'firebase/app';
import * as firebaseDB from "firebase/database";

const firebaseConfig = {
  apiKey: "AIzaSyCUJJOb0D7WKL6ux80owc4BDdZEBsFICJ4",
  authDomain: "test-project-4c72a.firebaseapp.com",
  databaseURL: "https://test-project-4c72a.firebaseio.com",
  projectId: "test-project-4c72a",
  storageBucket: "test-project-4c72a.appspot.com",
  messagingSenderId: "971899132380",
  appId: "1:971899132380:web:dad713dc18c55c1d49d719"
};

const app = initializeApp(firebaseConfig);
const db = firebaseDB.getDatabase(app);
const dbItemsRef = firebaseDB.ref(db, 'items');
const dbProjectsRef = firebaseDB.ref(db, 'projects');

const randomColor = function() {
  const o = Math.round, r = Math.random, s = 255;
  // Opaque equivalent of a 30% tint over white, so the wipe layer fully covers the old color
  const tint = () => o(s - 0.3 * (s - r()*s));
  const randomBgColor = 'rgb(' + tint() + ',' + tint() + ',' + tint() + ')';
  const wipe = document.createElement('div');
  wipe.className = 'bg-wipe';
  wipe.style.backgroundColor = randomBgColor;
  wipe.addEventListener('animationend', () => {
    document.body.style.backgroundColor = randomBgColor;
    wipe.remove();
  });
  document.body.appendChild(wipe);
  const randomFontColor = 'rgba(' + o(r()*(s/2)) + ',' + o(r()*(s/2)) + ',' + o(r()*(s/2)) + ',1)';
  document.body.style.color = randomFontColor;
}

// Shared input class
const INPUT = "w-full py-2.5 px-3 text-base bg-white/90 dark:bg-white/10 dark:text-white outline-none border-none rounded-xl font-comic font-semibold placeholder:font-normal placeholder:opacity-40";

// ──────────────────────────────────────
// Background stars
// ──────────────────────────────────────
const rand = (min, max) => min + Math.random() * (max - min);

class StarField extends React.Component {
  constructor(props) {
    super(props);
    this.state = { stars: [] };
    this.nextId = 0;
    this.spawnStar = this.spawnStar.bind(this);
  }

  componentDidMount() { this.interval = setInterval(this.spawnStar, 1000); }
  componentWillUnmount() { clearInterval(this.interval); }

  spawnStar() {
    const star = {
      id: this.nextId++,
      left: rand(0, 100),
      top: rand(0, 100),
      size: rand(10, 16),
      duration: rand(2, 6),
      wiggle: rand(15, 40),
    };
    this.setState(prev => ({ stars: [...prev.stars, star] }));
  }

  removeStar(id) { this.setState(prev => ({ stars: prev.stars.filter(s => s.id !== id) })); }

  render() {
    return (
      <div className="fixed inset-0 z-0 pointer-events-none overflow-hidden" aria-hidden="true">
        {this.state.stars.map(s => (
          <svg key={s.id} viewBox="0 0 24 24" className="bg-star"
            onAnimationEnd={() => this.removeStar(s.id)}
            style={{
              left: s.left + '%', top: s.top + '%', width: s.size, height: s.size,
              animationDuration: s.duration + 's', '--wiggle': s.wiggle + 'deg',
            }}>
            <path fill="currentColor" d="M12 2l2.9 6.9 7.1.6-5.4 4.7 1.6 7.1L12 17.6 5.8 21.3l1.6-7.1L2 9.5l7.1-.6z" />
          </svg>
        ))}
      </div>
    );
  }
}

// ──────────────────────────────────────
// GIF
// ──────────────────────────────────────
class Giphy extends React.Component {
  constructor(props) {
    super(props);
    this.state = { gif_tag: 'cute dogs', gif_url: '' };
    this.handleClick = this.handleClick.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.getGIF = this.getGIF.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleClick() {
    $("#gif").toggleClass('active');
    if ($("#gif").hasClass('active')) {
      setTimeout(() => { $("#gif input[type='text']").focus(); }, 300);
    }
  }

  handleChange(e) { this.setState({ gif_tag: e.target.value }); }

  getGIF() {
    const url = 'https://api.giphy.com/v1/gifs/random?api_key=gqHQubTws7lXVSN1DRqPdqjxuQSuy4qI&tag=' + this.state.gif_tag + '&limit=1&rating=pg';
    const comp = this;
    $.ajax({ url, method: 'GET' }).done(function(data) {
      comp.setState({ gif_url: data.data.images.downsized_large.url });
    });
  }

  handleSubmit(e) { e.preventDefault(); this.getGIF(); this.handleClick(); randomColor(); }
  componentDidMount() { this.getGIF(); }

  render() {
    return (
      <div id="gif" className="mb-5 rounded-2xl overflow-hidden">
        <img src={this.state.gif_url} onClick={this.handleClick} alt="" className="block w-full" />
        <button type="button" onClick={this.getGIF} aria-label="New gif"
          className="absolute top-3 right-3 z-[2] p-1.5 flex items-center justify-center bg-transparent border-none cursor-pointer text-base leading-none text-white drop-shadow-[0_1px_2px_rgba(0,0,0,0.6)] active:opacity-60">
          <i className="fa-solid fa-arrows-rotate fa-flip-horizontal" />
        </button>
        <form id="form-gif" onSubmit={this.handleSubmit} className="p-3">
          <div className="flex items-center gap-2 p-1.5 pl-4 rounded-full bg-white/95 dark:bg-zinc-800 shadow-lg">
            <input required type="text" placeholder="Search gifs..."
              value={this.state.gif_tag} onChange={this.handleChange} autoComplete="off" tabIndex="-1"
              className="flex-1 min-w-0 py-1.5 text-base bg-transparent text-black dark:text-white outline-none border-none font-comic font-semibold placeholder:font-normal placeholder:opacity-40" />
            <button type="submit" tabIndex="-1" aria-label="Get gif"
              className="shrink-0 w-9 h-9 flex items-center justify-center rounded-full text-base text-black dark:text-white bg-black/5 dark:bg-white/10 border-none cursor-pointer active:bg-black/10">
              <i className="fa-solid fa-check" />
            </button>
          </div>
        </form>
      </div>
    );
  }
}

// ──────────────────────────────────────
// Tabs — minimal underline style
// ──────────────────────────────────────
function TabBar({ activeTab, onTabChange }) {
  const tab = (id, label) => (
    <button key={id}
      onClick={() => onTabChange(id)}
      className={`pb-2 px-1 text-base font-comic font-bold uppercase border-none bg-transparent cursor-pointer transition-all duration-200
        ${activeTab === id ? 'tab-active' : ''}`}>
      {label}
    </button>
  );
  return (
    <div className="flex gap-5 mb-4 border-b border-black/5 dark:border-white/5">
      {tab('groceries', 'Groceries')}
      {tab('projects', 'Projects')}
    </div>
  );
}

// ──────────────────────────────────────
// Grocery — Add Form
// ──────────────────────────────────────
class AddForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = { item: '' };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange(e) { this.setState({ item: e.target.value }); }

  handleSubmit(e) {
    e.preventDefault();
    this.props.addItem(this.state.item);
    this.setState({ item: '' });
  }

  render() {
    return (
      <form onSubmit={this.handleSubmit} className="flex gap-2 mb-4">
        <input required type="text" placeholder="Add item..."
          value={this.state.item} onChange={this.handleChange} autoComplete="off"
          className={INPUT + " flex-1 uppercase"} />
        <button type="submit"
          className="px-4 text-base uppercase font-comic font-bold bg-white/90 dark:bg-white/10 border-none rounded-xl cursor-pointer active:bg-white/70">Add</button>
      </form>
    );
  }
}

// ──────────────────────────────────────
// Grocery — List
// ──────────────────────────────────────
function GroceryList({ items, removeItem }) {
  if (!items || Object.keys(items).length === 0) {
    return <p className="text-center opacity-50 text-base py-8 font-comic">No items yet</p>;
  }
  return (
    <div>
      {Object.entries(items).map(([key, value]) =>
        <ListItem key={key} itemID={key} item={value} removeItem={removeItem} />
      )}
    </div>
  );
}

// ──────────────────────────────────────
// Grocery — List Item
// ──────────────────────────────────────
class ListItem extends React.Component {
  componentDidMount() { randomColor(); }
  componentWillUnmount() { randomColor(); }

  render() {
    const { item, itemID, removeItem } = this.props;
    return (
      <div className="flex items-center gap-2 py-2 border-b border-black/[0.03] dark:border-white/[0.03] last:border-b-0">
        <span className="flex-1 min-w-0 font-comic font-bold text-lg uppercase break-words">{item.itemName}</span>
        <button onClick={() => removeItem(itemID)}
          className="shrink-0 w-8 h-8 flex items-center justify-center bg-transparent border-none text-base cursor-pointer rounded-full active:text-red-500"><i className="fa-solid fa-xmark" /></button>
      </div>
    );
  }
}

// ──────────────────────────────────────
// Projects — Add Form
// ──────────────────────────────────────
class AddProjectForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = { name: '' };
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit(e) {
    e.preventDefault();
    if (this.state.name.trim()) {
      this.props.addProject(this.state.name.trim());
      this.setState({ name: '' });
    }
  }

  render() {
    return (
      <form onSubmit={this.handleSubmit} className="flex gap-2 mb-4">
        <input required type="text" placeholder="New project..."
          value={this.state.name} onChange={e => this.setState({ name: e.target.value })} autoComplete="off"
          className={INPUT + " flex-1 uppercase"} />
        <button type="submit"
          className="px-4 text-base uppercase font-comic font-bold bg-white/90 dark:bg-white/10 border-none rounded-xl cursor-pointer active:bg-white/70">Add</button>
      </form>
    );
  }
}

// ──────────────────────────────────────
// Projects — Card
// ──────────────────────────────────────
class ProjectCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      expanded: false, editingSection: null,
      newStep: '',
      newSupplyName: '', newSupplyUrl: '', newSupplyCost: '',
      newContactName: '', newContactPhone: '', newContactEmail: '', newContactRole: '',
      newNote: '',
    };
    this.toggleExpand = this.toggleExpand.bind(this);
    this.handleAddStep = this.handleAddStep.bind(this);
    this.handleAddSupply = this.handleAddSupply.bind(this);
    this.handleAddContact = this.handleAddContact.bind(this);
    this.handleAddNote = this.handleAddNote.bind(this);
    this.toggleStep = this.toggleStep.bind(this);
    this.cycleStatus = this.cycleStatus.bind(this);
  }

  toggleExpand() { this.setState(p => ({ expanded: !p.expanded, editingSection: null })); }

  cycleStatus() {
    const order = ['not-started', 'in-progress', 'completed'];
    const cur = this.props.project.status || 'not-started';
    this.props.updateProject(this.props.projectID, { status: order[(order.indexOf(cur) + 1) % 3] });
  }

  toggleStep(i) {
    const steps = [...(this.props.project.steps || [])];
    steps[i] = { ...steps[i], completed: !steps[i].completed };
    this.props.updateProject(this.props.projectID, { steps });
  }

  handleAddStep(e) {
    e.preventDefault(); if (!this.state.newStep.trim()) return;
    const steps = [...(this.props.project.steps || []), { text: this.state.newStep.trim(), completed: false }];
    this.props.updateProject(this.props.projectID, { steps });
    this.setState({ newStep: '', editingSection: null });
  }

  handleAddSupply(e) {
    e.preventDefault(); if (!this.state.newSupplyName.trim()) return;
    const supplies = [...(this.props.project.supplies || []), { name: this.state.newSupplyName.trim(), url: this.state.newSupplyUrl.trim(), cost: this.state.newSupplyCost.trim() }];
    this.props.updateProject(this.props.projectID, { supplies });
    this.setState({ newSupplyName: '', newSupplyUrl: '', newSupplyCost: '', editingSection: null });
  }

  handleAddContact(e) {
    e.preventDefault(); if (!this.state.newContactName.trim()) return;
    const contacts = [...(this.props.project.contacts || []), { name: this.state.newContactName.trim(), phone: this.state.newContactPhone.trim(), email: this.state.newContactEmail.trim(), role: this.state.newContactRole.trim() }];
    this.props.updateProject(this.props.projectID, { contacts });
    this.setState({ newContactName: '', newContactPhone: '', newContactEmail: '', newContactRole: '', editingSection: null });
  }

  handleAddNote(e) {
    e.preventDefault(); if (!this.state.newNote.trim()) return;
    const notes = [...(this.props.project.notes || []), { text: this.state.newNote.trim(), createdAt: Date.now() }];
    this.props.updateProject(this.props.projectID, { notes });
    this.setState({ newNote: '', editingSection: null });
  }

  rm(field, i) {
    const arr = [...(this.props.project[field] || [])];
    arr.splice(i, 1);
    this.props.updateProject(this.props.projectID, { [field]: arr });
  }

  render() {
    const { project, projectID, removeProject } = this.props;
    const { expanded, editingSection } = this.state;
    const steps = project.steps || [];
    const supplies = project.supplies || [];
    const contacts = project.contacts || [];
    const notes = project.notes || [];
    const status = project.status || 'not-started';
    const done = steps.filter(s => s.completed).length;
    const statusLabel = { 'not-started': 'Not started', 'in-progress': 'In progress', 'completed': 'Done' }[status];
    const dotColor = { 'not-started': 'bg-gray-300 dark:bg-gray-600', 'in-progress': 'bg-blue-400', 'completed': 'bg-green-400' }[status];

    const ed = editingSection;
    const setEd = (s) => this.setState({ editingSection: ed === s ? null : s });

    return (
      <div className="bg-white/60 dark:bg-white/5 rounded-xl overflow-hidden">
        {/* Header */}
        <div className="flex items-center gap-2.5 p-3 cursor-pointer select-none" onClick={this.toggleExpand}>
          <span className={`shrink-0 w-2.5 h-2.5 rounded-full ${dotColor} cursor-pointer`}
            onClick={e => { e.stopPropagation(); this.cycleStatus(); }} />
          <div className="flex-1 min-w-0">
            <span className="block text-lg font-bold font-comic uppercase truncate">{project.name}</span>
            <span className="block text-base font-comic font-normal opacity-60 normal-case">
              {statusLabel}{steps.length > 0 && (' · ' + done + '/' + steps.length)}
            </span>
          </div>
          <span className={`text-base transition-transform duration-200 ${expanded ? 'rotate-180' : ''}`}><i className="fa-solid fa-chevron-down" /></span>
        </div>

        {expanded && (
          <div className="px-3 pb-3">
            {/* Steps */}
            <PSection title="Steps" onAdd={() => setEd('step')}>
              {steps.map((s, i) => (
                <div key={i} className={`flex items-center gap-2 py-1 ${s.completed ? 'opacity-30' : ''}`}>
                  <span onClick={() => this.toggleStep(i)}
                    className={`shrink-0 w-5 h-5 rounded flex items-center justify-center text-base cursor-pointer border
                      ${s.completed ? 'bg-green-400 border-green-500 text-white' : 'bg-transparent border-black/10 dark:border-white/10'}`}>
                    {s.completed ? <i className="fa-solid fa-check" /> : ''}
                  </span>
                  <span className={`flex-1 text-base font-comic font-normal normal-case break-words ${s.completed ? 'line-through' : ''}`}>{s.text}</span>
                  <RmBtn onClick={() => this.rm('steps', i)} />
                </div>
              ))}
              {ed === 'step' && (
                <form className="flex gap-2 mt-1" onSubmit={this.handleAddStep}>
                  <input type="text" placeholder="Step description" value={this.state.newStep}
                    onChange={e => this.setState({ newStep: e.target.value })} autoFocus autoComplete="off"
                    className={INPUT + " flex-1 !py-2 !text-base normal-case !font-normal"} />
                  <GoBtn />
                </form>
              )}
            </PSection>

            {/* Supplies */}
            <PSection title="Supplies" onAdd={() => setEd('supply')}>
              {supplies.map((s, i) => (
                <div key={i} className="flex items-center gap-2 py-1">
                  <div className="flex-1 min-w-0">
                    <span className="text-base font-comic font-semibold normal-case break-words">
                      {s.url ? <a href={s.url} target="_blank" rel="noopener noreferrer" className="text-blue-500 dark:text-blue-400 no-underline">{s.name} ↗</a> : s.name}
                    </span>
                    {s.cost && <span className="ml-1.5 text-base opacity-60 font-comic font-normal">{s.cost}</span>}
                  </div>
                  <RmBtn onClick={() => this.rm('supplies', i)} />
                </div>
              ))}
              {ed === 'supply' && (
                <form className="flex flex-col gap-1.5 mt-1" onSubmit={this.handleAddSupply}>
                  <input type="text" placeholder="Item name" value={this.state.newSupplyName}
                    onChange={e => this.setState({ newSupplyName: e.target.value })} autoFocus autoComplete="off"
                    className={INPUT + " !py-2 !text-base normal-case !font-normal"} />
                  <input type="url" placeholder="Link (optional)" value={this.state.newSupplyUrl}
                    onChange={e => this.setState({ newSupplyUrl: e.target.value })} autoComplete="off"
                    className={INPUT + " !py-2 !text-base normal-case !font-normal"} />
                  <input type="text" placeholder="Cost (optional)" value={this.state.newSupplyCost}
                    onChange={e => this.setState({ newSupplyCost: e.target.value })} autoComplete="off"
                    className={INPUT + " !py-2 !text-base normal-case !font-normal"} />
                  <GoBtn label="Add supply" />
                </form>
              )}
            </PSection>

            {/* Contacts */}
            <PSection title="Contacts" onAdd={() => setEd('contact')}>
              {contacts.map((c, i) => (
                <div key={i} className="flex items-start gap-2 py-1.5">
                  <div className="flex-1 min-w-0">
                    <span className="text-base font-comic font-semibold normal-case">{c.name}</span>
                    {c.role && <span className="ml-1.5 text-base opacity-60 font-comic font-normal normal-case">{c.role}</span>}
                    <div className="flex flex-wrap gap-3 mt-0.5">
                      {c.phone && <a href={'tel:' + c.phone} className="text-base text-blue-500 dark:text-blue-400 no-underline font-comic font-normal normal-case"><i className="fa-solid fa-phone mr-1" />{c.phone}</a>}
                      {c.email && <a href={'mailto:' + c.email} className="text-base text-blue-500 dark:text-blue-400 no-underline font-comic font-normal normal-case break-all"><i className="fa-solid fa-envelope mr-1" />{c.email}</a>}
                    </div>
                  </div>
                  <RmBtn onClick={() => this.rm('contacts', i)} />
                </div>
              ))}
              {ed === 'contact' && (
                <form className="flex flex-col gap-1.5 mt-1" onSubmit={this.handleAddContact}>
                  <input type="text" placeholder="Name" value={this.state.newContactName}
                    onChange={e => this.setState({ newContactName: e.target.value })} autoFocus autoComplete="off"
                    className={INPUT + " !py-2 !text-base normal-case !font-normal"} />
                  <input type="text" placeholder="Role (optional)" value={this.state.newContactRole}
                    onChange={e => this.setState({ newContactRole: e.target.value })} autoComplete="off"
                    className={INPUT + " !py-2 !text-base normal-case !font-normal"} />
                  <input type="tel" placeholder="Phone (optional)" value={this.state.newContactPhone}
                    onChange={e => this.setState({ newContactPhone: e.target.value })} autoComplete="off"
                    className={INPUT + " !py-2 !text-base normal-case !font-normal"} />
                  <input type="email" placeholder="Email (optional)" value={this.state.newContactEmail}
                    onChange={e => this.setState({ newContactEmail: e.target.value })} autoComplete="off"
                    className={INPUT + " !py-2 !text-base normal-case !font-normal"} />
                  <GoBtn label="Add contact" />
                </form>
              )}
            </PSection>

            {/* Notes */}
            <PSection title="Notes" onAdd={() => setEd('note')}>
              {notes.map((n, i) => (
                <div key={i} className="flex items-start gap-2 py-1">
                  <span className="flex-1 text-base font-comic font-normal normal-case whitespace-pre-wrap break-words">{n.text || n}</span>
                  <RmBtn onClick={() => this.rm('notes', i)} />
                </div>
              ))}
              {ed === 'note' && (
                <form className="flex flex-col gap-1.5 mt-1" onSubmit={this.handleAddNote}>
                  <textarea placeholder="Note..." value={this.state.newNote}
                    onChange={e => this.setState({ newNote: e.target.value })} autoFocus rows="2"
                    className="w-full py-2 px-3 text-base bg-white/90 dark:bg-white/10 dark:text-white outline-none border-none rounded-xl font-comic font-normal normal-case resize-y min-h-[50px]" />
                  <GoBtn label="Add note" />
                </form>
              )}
            </PSection>

            {/* Delete */}
            <div className="pt-2 mt-1 text-center">
              <button className="bg-transparent border-none text-base text-red-400 font-comic font-bold uppercase cursor-pointer"
                onClick={() => { if (window.confirm('Delete "' + project.name + '"?')) removeProject(projectID); }}>
                Delete project
              </button>
            </div>
          </div>
        )}
      </div>
    );
  }
}

// ──────────────────────────────────────
// Shared tiny components
// ──────────────────────────────────────
function PSection({ title, onAdd, children }) {
  return (
    <div className="py-2 border-t border-black/[0.04] dark:border-white/[0.04] first:border-t-0">
      <div className="flex items-center justify-between mb-1">
        <span className="text-base uppercase font-comic font-bold opacity-60 tracking-wider">{title}</span>
        <button onClick={onAdd}
          className="text-base uppercase font-comic font-bold bg-transparent border-none cursor-pointer">+ Add</button>
      </div>
      {children}
    </div>
  );
}

function RmBtn({ onClick }) {
  return (
    <button onClick={onClick}
      className="shrink-0 w-6 h-6 flex items-center justify-center bg-transparent border-none text-base cursor-pointer rounded-full active:text-red-500"><i className="fa-solid fa-xmark" /></button>
  );
}

function GoBtn({ label }) {
  return (
    <button type="submit"
      className="self-start px-3 py-1.5 text-base uppercase font-comic font-bold bg-black/5 dark:bg-white/10 border-none rounded-lg cursor-pointer active:bg-black/10">
      {label || 'Add'}
    </button>
  );
}

// ──────────────────────────────────────
// Projects — List
// ──────────────────────────────────────
function ProjectList({ projects, updateProject, removeProject }) {
  if (!projects || Object.keys(projects).length === 0) {
    return <p className="text-center opacity-50 text-base py-8 font-comic">No projects yet</p>;
  }
  return (
    <div className="flex flex-col gap-2">
      {Object.entries(projects).map(([key, project]) => (
        <ProjectCard key={key} projectID={key} project={project}
          updateProject={updateProject} removeProject={removeProject} />
      ))}
    </div>
  );
}

// ──────────────────────────────────────
// App
// ──────────────────────────────────────
class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = { groceryItems: [], projects: null, activeTab: 'groceries' };
    this.addItem = this.addItem.bind(this);
    this.removeItem = this.removeItem.bind(this);
    this.addProject = this.addProject.bind(this);
    this.updateProject = this.updateProject.bind(this);
    this.removeProject = this.removeProject.bind(this);
    this.setActiveTab = this.setActiveTab.bind(this);
  }

  componentDidMount() {
    firebaseDB.onValue(dbItemsRef, (snapshot) => { this.setState({ groceryItems: snapshot.val() }); });
    firebaseDB.onValue(dbProjectsRef, (snapshot) => { this.setState({ projects: snapshot.val() }); });
  }

  addItem(item) {
    const ref = firebaseDB.push(dbItemsRef);
    firebaseDB.set(ref, { itemName: item });
  }

  removeItem(id) { firebaseDB.remove(firebaseDB.ref(db, 'items/' + id)); }

  addProject(name) {
    const ref = firebaseDB.push(dbProjectsRef);
    firebaseDB.set(ref, { name, status: 'not-started', steps: [], supplies: [], contacts: [], notes: [], createdAt: Date.now() });
  }

  updateProject(id, u) { firebaseDB.update(firebaseDB.ref(db, 'projects/' + id), u); }
  removeProject(id) { firebaseDB.remove(firebaseDB.ref(db, 'projects/' + id)); }
  setActiveTab(tab) { this.setState({ activeTab: tab }); }

  render() {
    const { groceryItems, projects, activeTab } = this.state;

    return (
      <div className="max-w-[500px] mx-auto">
        <StarField />
        <Giphy />
        <TabBar activeTab={activeTab} onTabChange={this.setActiveTab} />
        <div className="min-h-[40vh]">
          {activeTab === 'groceries' && (
            <div className="animate-fade-in">
              <AddForm addItem={this.addItem} />
              <GroceryList items={groceryItems} removeItem={this.removeItem} />
            </div>
          )}
          {activeTab === 'projects' && (
            <div className="animate-fade-in">
              <AddProjectForm addProject={this.addProject} />
              <ProjectList projects={projects} updateProject={this.updateProject} removeProject={this.removeProject} />
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default App;
